import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { getMyOrders, getMyOrdersSuccess, getMyOrdersFailed } from "./slice";

//--------------------getMyOrdersSagas-------------------------

function* getMyOrdersSagas(action: ReturnType<typeof getMyOrders>): any {
  try {
    const { page, limit, search, type } = action.payload;
    const queryParams = new URLSearchParams({
      search: search || "",
      type: type || "",
      limit: String(limit),
      page: String(page),
    }).toString();

    const response = yield call(
      request.get,
      `${endpoints.getMyOrders}?${queryParams}`
    );  
    yield put(getMyOrdersSuccess(response));
  } catch (error: any) {
    yield put(getMyOrdersFailed(error));
  }
}

function* myOrdersSagas() {
  yield all([takeLatest(getMyOrders, getMyOrdersSagas)]);
}

export { myOrdersSagas };
